import './EasterEgg.css';
import { useEffect, useState } from 'react';

function Easteregg() {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  // Более надежная проверка на сенсорное устройство
  useEffect(() => {
    const checkTouchDevice = () => {
      // Проверяем поддержку touch-событий или наличие тач-интерфейса
      const isTouch = 'ontouchstart' in window || 
                     navigator.maxTouchPoints > 0 || 
                     navigator.msMaxTouchPoints > 0;
      
      // Дополнительная проверка через media-query
      const isCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
      
      setIsTouchDevice(isTouch || isCoarsePointer);
    };

    checkTouchDevice();
    window.addEventListener('resize', checkTouchDevice);
    
    return () => {
      window.removeEventListener('resize', checkTouchDevice);
    };
  }, []);

  const enterFullscreen = () => {
    const elem = document.querySelector('.emulator-container');
    if (!elem) return;
    
    if (elem.requestFullscreen) {
      elem.requestFullscreen().catch(err => {
        console.log('Fullscreen error:', err);
      });
    }
  };

  return (
    <div className='sonic'>
      <title>Пасхалка Sonic 1</title>
      <h1 className='gametitle'>Sonic 1</h1>
      <div className="emulator-container">
        <iframe 
          src='/sonic1.html' 
          title="Sonic 1 Emulator"
          allow="fullscreen"
        ></iframe>
      </div>
      
      {isTouchDevice && (
        <button 
          className="fullscreen-btn-easter"
          onClick={enterFullscreen}
          aria-label="Развернуть игру на весь экран"
        >
          <span className="fullscreen-icon">⛶</span>
          Полноэкранный режим
        </button>
      )}
    </div>
  );
}

export default Easteregg;